"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.manualEntry_0 = void 0;
var manualEntry_0 = function (utils) {
    var loadPrimaryInput = utils.loadPrimaryInput, a11yHasExpectedHtml = utils.a11yHasExpectedHtml, a11yInitialHtml = utils.a11yInitialHtml, hasReturnVal = utils.hasReturnVal;
    describe('Manual entry - 0', function () {
        it('0 0 0 0 A', function () {
            loadPrimaryInput({ segment: 'hrs12' })
                .type('0')
                .should('have.value', '12:30 PM')
                .then(a11yHasExpectedHtml('<p>12.</p>'))
                .then(hasReturnVal('12:30'))
                .type('0')
                .should('have.value', '12:30 PM')
                .then(a11yHasExpectedHtml(a11yInitialHtml().minutes))
                .then(hasReturnVal('12:30'))
                .type('0')
                .should('have.value', '12:00 PM')
                .then(a11yHasExpectedHtml('<p>0.</p>'))
                .then(hasReturnVal('12:00'))
                .type('0')
                .should('have.value', '12:00 PM')
                .then(a11yHasExpectedHtml(a11yInitialHtml().mode))
                .then(hasReturnVal('12:00'))
                .type('a')
                .should('have.value', '12:00 AM')
                .then(a11yHasExpectedHtml('<p>AM.</p>'))
                .then(hasReturnVal('00:00'));
        });
    });
};
exports.manualEntry_0 = manualEntry_0;
